import Analytics from "analytics/util/Analytics";

import { STACKS_STATUSES } from "apps/quickmatch/util/constants";
import { formatStacksExpirationTime } from "apps/quickmatch/util/helpers";

const getStackPaidStatus = (stack = {}) => {
	return stack.status === STACKS_STATUSES.PAYWALL || !!stack.expireTime
		? "paid"
		: "free";
};

export const loadStacksAnalytics = (data) => {
	const stackOrder = [];
	const queueSizes = [];
	const emptyCauses = [];
	const paidStatuses = [];
	const daysLeft = [];

	data.forEach((stack) => {
		stackOrder.push(stack.id);
		queueSizes.push(stack.votesRemaining);
		emptyCauses.push(stack.status);
		paidStatuses.push(getStackPaidStatus(stack));

		if (stack.expireTime) {
			daysLeft.push(formatStacksExpirationTime(stack.expireTime));
		} else {
			daysLeft.push(0);
		}
	});

	Analytics.logUIEvent(Analytics.eventNames.stacksLoadedStacks, {
		type: Analytics.eventTypes.user_content,
		data: {
			"stack order": stackOrder.join(","),
			"queue size": queueSizes.join(","),
			"empty causes": emptyCauses.join(","),
			paid: paidStatuses.join(","),
			"days left": daysLeft.join(","),
		},
	});
};

export const clickedOnStackAnalytics = ({ stack, stackOrder }) => {
	Analytics.logUIEvent(Analytics.eventNames.stacksClickedStack, {
		type: Analytics.eventTypes.user_content,
		data: {
			stack: stack.id,
			paid: getStackPaidStatus(stack),
			"days left": stack.expireTime
				? formatStacksExpirationTime(stack.expireTime)
				: 0,
			"stack index": stackOrder.indexOf(stack.id),
		},
	});
};

export const loadStackAnalytics = (stack = {}, stackOrder = []) => {
	if (!stack.id) {
		return;
	}

	Analytics.logUIEvent(Analytics.eventNames.stacksLoadedStack, {
		type: Analytics.eventTypes.user_content,
		data: {
			stack: stack.id,
			"queue size": (stack.data || []).length,
			cta: stack.status,
			"stack order": stackOrder.join(","),
			paid: getStackPaidStatus(stack),
			"days left": stack.expireTime
				? formatStacksExpirationTime(stack.expireTime)
				: 0,
		},
	});
};

export const reachedDailyLimitAnalytics = (stackId) => {
	Analytics.logUIEvent(Analytics.eventNames.stacksReachedDailyLimit, {
		data: {
			stack: stackId,
		},
	});
};

export function stacksPassAnalyticsAttrs(activeStackId) {
	return {
		promoid: "stacks.stackpass",
		"promo design": activeStackId,
		feature: "stackpass",
		source: "doubletake",
	};
}

export function selectedFirstPartyPromoEvent(activeStackId) {
	const analyticsAttrs = stacksPassAnalyticsAttrs(activeStackId);

	Analytics.logUIEvent(
		Analytics.eventNames.selectedFirstPartyPromo, {
			data: {
				...analyticsAttrs,
				interaction: "clicked",
				source: "doubletake",
				"feature type": "token",
			},
		},
	);
}

export function viewedStackPassRateCardEvent(activeStackId) {
	const analyticsAttrs = stacksPassAnalyticsAttrs(activeStackId);
	Analytics.logUIEvent(Analytics.eventNames.viewedRateCard, {
		data: {
			...analyticsAttrs,
		},
	});
}

export function selectedPackageOnStackPassRateCardEvent(activeStackId) {
	const analyticsAttrs = stacksPassAnalyticsAttrs(activeStackId);
	Analytics.logUIEvent(Analytics.eventNames.selectedPackageOnRateCard, {
		data: {
			...analyticsAttrs,
		},
	});
}

export function unlockedStackEvent(activeStackId) {
	Analytics.logUIEvent(Analytics.eventNames.unlockedStack, {
		data: {
			stack: activeStackId,
		},
	});
}

export function showCtaEvent(stack) {
	if (!stack.status) {
		return;
	}

	Analytics.logUIEvent(Analytics.eventNames.cta, {
		type: Analytics.eventTypes.user_content,
		data: {
			"display location": stack.id,
			"cta name": stack.status,
		},
	});
}



// WEBPACK FOOTER //
// ./src/apps/quickmatch/util/analytics.js